/**
 * FARKTOR UI Component Library
 * 
 * Tüm componentler bu dosyada merkezi olarak yönetilir.
 * Stiller: src/styles/ui.css
 */

import { ReactNode } from 'react'

// Export all UI components
export { Badge } from './ui/Badge'
export { Toggle } from './ui/Toggle'
export { TableActionMenu } from './ui/TableActionMenu'
export { useDragDrop } from './ui/useDragDrop'
export { Table } from './ui/Table'
export { Modal } from './ui/Modal'
export { ModalProvider, useModalContext } from './ui/ModalContext'
export { Input, Textarea, Select, FormGroup } from './ui/Input'
export { TagInput } from './ui/TagInput'
export { CheckboxList } from './ui/CheckboxList'
export type { CheckboxListOption } from './ui/CheckboxList'
export type { ActionMenuItem } from './ui/TableActionMenu'
export type { ModalPosition, ModalSize, ModalButton } from './ui/Modal'

// Geçici olarak Card component'i koruyalım
interface CardProps {
  children: ReactNode
  className?: string
}

export function Card({ children, className = '' }: CardProps) {
  return (
    <div className={`ui-card ${className}`.trim()}>
      {children}
    </div>
  )
}

export function CardHeader({ children, className = '' }: CardProps) {
  return (
    <div className={`ui-card__header ${className}`.trim()}>
      {children}
    </div>
  )
}

export function CardTitle({ children, className = '' }: CardProps) {
  return (
    <h3 className={`ui-card__title ${className}`.trim()}>
      {children}
    </h3>
  )
}

export function CardDescription({ children, className = '' }: CardProps) {
  return (
    <p className={`ui-card__description ${className}`.trim()}>
      {children}
    </p>
  )
}

export function CardContent({ children, className = '' }: CardProps) {
  return (
    <div className={`ui-card__content ${className}`.trim()}>
      {children}
    </div>
  )
}

export function CardFooter({ children, className = '' }: CardProps) {
  return (
    <div className={`ui-card__footer ${className}`.trim()}>
      {children}
    </div>
  )
}
